import React from 'react';
import { LandingPage } from '../../LandingPage/LandingPage';
export const AuthorisingLandingPage = () => React.createElement(LandingPage, { shouldShowLoadingIcon: true, title: "Authorising...", qaIdBase: "landingPageAuthPending" });
